export const role_client = [
    {title: 'profile_record', icon: 'dns', route: 'cabinet/data_archive'},
    {title: 'profile_dynamic', icon: 'insert_chart_outlined', route: 'cabinet/my-health-dynamic'},
    {title: 'profile_screaningTitile', icon: 'timeline', route: 'cabinet/screaning'},
    {title: 'profile_reservations', icon: 'featured_play_list', route: 'cabinet/my-booked-services'},
    {title: 'profile_analyses', icon: 'list_alt', route: 'cabinet/my-analyse'}
]


export const specialist_mode = [
    {title: 'profile_schedules', icon: 'data_range', route: 'cabinet/schedule'},
    {title: 'profile_my_patients', icon: 'calendar', route: 'cabinet/clients'},
    {title: 'profile_services', icon: 'featured_play_list', route: 'cabinet/service'},
    {title: 'profile_analyses', icon: 'list_alt', route: 'cabinet/referral'}
]
